// extracted by mini-css-extract-plugin
export var actions = "_gs-g";
export var benefitCard = "_gs-b";
export var benefitIcon = "_gs-d";
export var benefitLabel = "_gs-f";
export var benefits = "_gs-a";
export var benefitsSection = "_gs-8";
export var bodyText = "_gs-7";
export var closeButton = "_gs-2";
export var content = "_gs-3";
export var eyebrow = "_gs-4";
export var heading = "_gs-5";
export var image = "_gs-i";
export var imagePanel = "_gs-h";
export var modal = "_gs-0";
export var offerCard = "_gs-c";
export var offerIcon = "_gs-e";
export var sectionLabel = "_gs-9";
export var shell = "_gs-1";
export var title = "_gs-6";